import React, {useState} from "react";
import {
    ButtonPrimary,
    Heading
} from "pac-ux-components";
import Loading from "../Loading";
import usePacProducts from "../../hooks/usePacProducts";
import AddPacProductModal from "./AddPacProductModal";
import EditPacProductModal from "./EditPacProductModal";
import StoreSelectionModal from "./StoreSelectionModal";
import Add24 from "pac-ux-components/build/Icons/Navigation/Add24";

function PacProductList() {
    const {products, loading, setLoading, error, setError, handleSave, addingPacProduct, setEditingPacProduct, setAddingPacProduct, editingPacProduct} = usePacProducts();
    const [editingStores, setEditingStores] = useState(null);


    function handleClickStores(storeId) {
        setEditingStores(storeId);
    }

    function handleClickProduct(product) {
        setEditingPacProduct(product);
    }



    const handleCloseModal = (refresh) => {
        setEditingStores(null);
        if (refresh) {
            window.location.reload();
        }
    }

    if (loading) return (<Loading/>);

    if (error) return <p>Error: {error}</p>;


    return (<div className="PacProducts" style={{width: 1047}}>

        <Heading color={'#10304C'} style={{paddingTop: 56, paddingBottom: 16}}

        >PAC Products</Heading>
        <div style={{float: 'right', marginTop: '-50px'}}>
            <ButtonPrimary
                onClick={() => {
                    setAddingPacProduct(true)
                }}
            ><Add24/> Add PAC Product </ButtonPrimary>
        </div>


        <table width="1047px" className="Table" style={{}}>
            <thead>
            <tr style={{fontWeight: 600, height: 48, fontSize: 16, fontFamily: 'Inter', border: "thin solid #E0E0E0"}}>
                <td width="270" style={{paddingLeft: 32}}>Product</td>
                <td>Stores</td>
                <td width="300">Client Id</td>

            </tr>
            </thead>
            <tbody>
            {products.map((product, index) => (<tr key={product.id} style={{
                height: 48,
                fontSize: 16,
                fontWeight: 400,
                backgroundColor: index % 2 === 0 ? '#EDEDED' : '#FFFFFF',
                border: "thin solid #E0E0E0"
            }}>
                <td style={{paddingLeft: 32}}>
                    <span onClick={() => handleClickProduct(product)} style={{cursor: 'pointer'}}>{product.name}</span>
                </td>
                <td> <span onClick={() => handleClickStores(product.id)}
                           style={{cursor: 'pointer'}}>{product.stores}<img
                    src="/image/pencil.svg" width={24} height={23} style={{marginLeft: '20px'}} alt="Change"/></span>
                </td>
                <td>
                    {product.clientId}
                </td>

            </tr>))}
            </tbody>
        </table>

        {editingStores !== null && (
            <StoreSelectionModal
                productId={editingStores}
                display={editingStores === null ? false : true}
                closeModal={handleCloseModal}/>
        )}

        {addingPacProduct === true && (
            <AddPacProductModal
                display={true}
                handleSave={handleSave}
                closeModal={() => setAddingPacProduct(false)}/>
        )}

        {editingPacProduct !== null && (
            <EditPacProductModal
                product={editingPacProduct}
                display={editingPacProduct === null ? false : true}
                handleSave={handleSave}
                closeModal={() => setEditingPacProduct(null)}/>
        )}

    </div>);
}

export default PacProductList;